import { render, staticRenderFns } from "./SelectColor.vue?vue&type=template&id=619725c3&scoped=true"
import script from "./SelectColor.js?vue&type=script&lang=js&external"
export * from "./SelectColor.js?vue&type=script&lang=js&external"
import style0 from "./SelectColor.scss?vue&type=style&index=0&id=619725c3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619725c3",
  null
  
)

export default component.exports